export enum ReasonInitialStep {
  StopActivity = 'StopActivity',
  Satisfied = 'Satisfied',
  Unsatisfied = 'Unsatisfied',
  Other = 'Other',
}

export enum ReasonCompetitionStep {
  Yes = 'yes',
  No = 'no',
}
